import "./App.css";
import { Route, Routes } from "react-router-dom";
import About from "./Component/About/About";
import Introduction from "./Component/Introduction/Introduction";
import MySkill from "./Component/MySkills/MySkill";
import Contact from "./Component/Contact/Contact";
import Intermetent from "./Component/Intermetent";
import FinalPage from "./Component/FinalPage";
import Sorry from "./Component/Sorry"
import AboutHomePage from "./Page/HomePage/AboutHomePage";
import ExperienceRoute from "./Component/Experience/ExperienceRoute";
function App() {
  return (
    <div>
      <Routes>
        <Route exact path="/" element={<Introduction />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/mySkill" element={<MySkill />} />
        <Route exact path="/Contact" element={<Contact />} />
        <Route exact path="/Contact" element={<AboutHomePage/>} />
        <Route exact path="/Experience" element={<ExperienceRoute/>} />
        <Route exact path="/Intermetent" element={<Intermetent />} />
        <Route exact path="/FinalPage" element={<FinalPage />} />
        <Route exact path="/Sorry" element={<Sorry />} />
      </Routes>
    </div>
  );
}

export default App;
